var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNameIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 30,
    viewBox: "0 0 35 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.97607 22.5C5.97607 21.1739 6.56818 19.9021 7.62213 18.9645C8.67609 18.0268 10.1056 17.5 11.5961 17.5H22.8361C24.3266 17.5 25.7561 18.0268 26.81 18.9645C27.864 19.9021 28.4561 21.1739 28.4561 22.5C28.4561 23.163 28.16 23.7989 27.633 24.2678C27.1061 24.7366 26.3913 25 25.6461 25H8.78607C8.04082 25 7.32608 24.7366 6.7991 24.2678C6.27213 23.7989 5.97607 23.163 5.97607 22.5Z",
    stroke: "#BDBDBD",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.216 12.5C19.5439 12.5 21.431 10.8211 21.431 8.75C21.431 6.67893 19.5439 5 17.216 5C14.8881 5 13.001 6.67893 13.001 8.75C13.001 10.8211 14.8881 12.5 17.216 12.5Z",
    stroke: "#BDBDBD",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNameIcon);
export default __webpack_public_path__ + "static/media/name_icon.20b6bb1993084285515fef1e9bfd4022.svg";
export { ForwardRef as ReactComponent };